{
  "LOGIN": {
    "TITLE": "Conectează-te la centrul de contact",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă"
    },
    "PASSWORD": {
      "LABEL": "Parola",
      "PLACEHOLDER": "Parola"
    },
    "API": {
      "SUCCESS_MESSAGE": "Autentificare reușită",
      "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou.",
      "UNAUTH": "Numele de utilizator sau parola sunt incorecte. Vă rugăm să încercați din nou.",
      "ACCOUNT_DEACTIVATED": "Contul dumneavoastră a fost dezactivat. Vă rugăm să contactați administratorul.",
      "PASSWORD_LOGIN_DISABLED": "Autentificarea cu parolă este dezactivată pentru contul dumneavoastră. Vă rugăm să vă autentificați folosind OAuth (de ex. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Autentifica-te cu Google+",
      "BUSINESS_ACCOUNTS_ONLY": "Vă rugăm să utilizați adresa de e-mail a companiei pentru a vă autentifica",
      "NO_ACCOUNT_FOUND": "Nu am putut găsi un cont pentru adresa ta de e-mail."
    },
    "FORGOT_PASSWORD": "Ai uitat parola?",
    "CREATE_NEW_ACCOUNT": "Creează un cont nou",
    "SUBMIT": "Conectează-te"
  }
}
